import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/nextjs/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/nextjs/src/styles/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["useAppConfigContext"] */ "/app/node_modules/@constructr-sdk/core/dist/config/context/app-config-context.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@constructr-sdk/modules/dist/foundation/cookie-consent.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@constructr-sdk/modules/dist/foundation/providers.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["MadeWithBadge"] */ "/app/node_modules/@constructr-sdk/ui/src/components/made-with-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/@constructr-sdk/ui/src/components/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"../../node_modules/geist/dist/mono.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/geist-mono/GeistMono-Variable.woff2\",\"variable\":\"--font-geist-mono\",\"adjustFontFallback\":false,\"fallback\":[\"ui-monospace\",\"SFMono-Regular\",\"Roboto Mono\",\"Menlo\",\"Monaco\",\"Liberation Mono\",\"DejaVu Sans Mono\",\"Courier New\",\"monospace\"],\"weight\":\"100 900\"}],\"variableName\":\"GeistMono\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"../../node_modules/geist/dist/sans.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/geist-sans/Geist-Variable.woff2\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"GeistSans\"}");
